import { ISurveyQuestion } from "../common/data/dtos/survey-question";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/SurveyQuestion';

interface SurveyQuestionResponse {
    success: boolean;
    surveyQuestion?: ISurveyQuestion;
    surveyQuestions?: ISurveyQuestion[];
    error?: string;
}

type CreateSurveyQuestionType = Omit<ISurveyQuestion, 'id'> | Partial<ISurveyQuestion>;

const createSurveyQuestion = async (surveyQuestion: CreateSurveyQuestionType): Promise<SurveyQuestionResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}`, surveyQuestion);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteSurveyQuestion = async (id: string): Promise<SurveyQuestionResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyQuestions = async (): Promise<SurveyQuestionResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestions: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneSurveyQuestion = async (id: string): Promise<SurveyQuestionResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestion: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateSurveyQuestion = async (surveyQuestion: ISurveyQuestion): Promise<SurveyQuestionResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}/${surveyQuestion.id}`, surveyQuestion);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyQuestionBySurvey = async (id: string): Promise<SurveyQuestionResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestion>(`${BASE_PATH}/GetBySurvey?id=${id}`);
        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestions: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createSurveyQuestion,
    deleteSurveyQuestion,
    getSurveyQuestions,
    getOneSurveyQuestion,
    updateSurveyQuestion,
    getSurveyQuestionBySurvey
};